const PUBLIC_IMAGE_RE = /\/images\/([^?#]+)\.(jpe?g|png)$/i;

export const getOptimizedPublicImage = (src) => {
  if (!src || !PUBLIC_IMAGE_RE.test(src)) return src;
  return src.replace(PUBLIC_IMAGE_RE, "/images/$1.webp");
};

export const hasOptimizedPublicImage = (src) => getOptimizedPublicImage(src) !== src;
